<template>

  <div class="container text contenedor ancho-lectura m-y-2-sm m-y-3-md">
    <div class="tmp-credito-detalle">
      <div class="img">
        <img :src="persona.foto != undefined ? require(`@/assets/img/investigadorxs/${persona.foto}`) : '' " :alt="persona.nombre" :class="{'none-display': tieneVistaSimplificada}">
      </div>
      <div class="text">
        <p class="nombre">{{persona.nombre}}</p>
        <p class="cargo">{{persona.cargo}}</p>
      </div>
    </div>
    <hr :style="[tieneVistaSimplificada ? {'display': 'none'} : {'display': 'block'}]"/>
    <p v-for="(parrafo, index) in persona.semblanza" :key="`parrafo-${index}`">
      {{parrafo}}
    </p>
    <router-link to="/colaboracion">Regresar</router-link>
  </div>

</template>

<script>
import personas from '@/assets/data/sargazo_investigadorxs.json';

export default {
  name: "PaginaCreditosDetalle",
  data(){
    return {
      persona: {},
    }
  },
  mounted() {
    this.persona = personas.filter(d => d.id == this.$route.params.id)[0];
  },
  computed: {
    tieneVistaSimplificada(){
      return this.$store.getters.tieneVistaSimplificada;
    }
  },
}
</script>

<style lang="scss">
.tmp-credito-detalle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .img {
    flex: 1 0 120px;
    width: 120px;
    img {
      border-radius: 50%;
      width: 120px;
      height: 120px;
      &.none-display {
        display: none;
      }
    }
  }
  .text {
    flex: 1 1 100%;
    font-size: 16px;
    margin: 0 0 0 16px;
    * {
      margin: 8px 0;
      line-height: 1em;
    }
  }
  .nombre {
    font-size: 22px;
    font-weight: 500;
  }
  .cargo {
    line-height: inherit;
  }
  .institucion {
    color: #6f7271;
  }
}
</style>
